<template>
  <div>
    <b-card>
      <template slot="header">
        <b-card-title>
          <strong>{{title}}</strong>
        </b-card-title>
        <p class="card-category mt-4">{{subTitle}}</p>
      </template>
      <template slot="default">
        <b-row>
          <b-col>
            <div class="text-center mb-4 mt-4">
              <p-button type="success" round size="sm" @click.native="sendResetPasswordRequest">Reset Password</p-button>
            </div>
          </b-col>
        </b-row>
        <b-loading :loading="processing" />
      </template>
    </b-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "Reset Password",
      subTitle: "We'll send you an email to reset your password.",
      processing: false
    }
  },
  methods: {
    sendResetPasswordRequest() {
      this.processing = true
      this.$store.dispatch('resetPasswordRequest').then(() => {
        this.processing = false
        this.$bvToast.toast('Password Reset Email sent successfully.', {
          title: `Auth`,
          variant: 'custom',
          solid: true
        })
      })
    }
  }
}
</script>
<style>
</style>
